// extracted by mini-css-extract-plugin
module.exports = {"SectionBanner":"BalleteatroView_SectionBanner__3_9xS","Wrapper":"BalleteatroView_Wrapper__Yjkds","Title":"BalleteatroView_Title__KjZDR","Action":"BalleteatroView_Action__1Fv9W"};